export const HelpIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.258 8.02434C11.3087 7.86152 10.3528 8.42334 10.0332 9.33187C9.8499 9.85286 9.27899 10.1266 8.758 9.94336C8.23701 9.76008 7.96323 9.18917 8.14651 8.66818C8.78571 6.85112 10.6976 5.72749 12.5961 6.05313C14.4943 6.37873 15.9224 8.07495 15.9198 10.0009C15.9193 11.8206 14.3133 13.0514 12.7947 13.7263C12.2145 13.9842 11.2281 14.0872 10.9712 13.3162C10.6035 12.2133 12.1751 11.878 12.8651 11.418C14.2896 10.4683 14.1937 8.35636 12.258 8.02434Z"
        fill="currentColor"
      />
      <path
        d="M11 17C11 17.5523 11.4477 18 12 18C12.5487 18 13.01 17.5529 13.01 17C13.01 16.4477 12.5623 16 12.01 16C11.4613 16 11 16.4471 11 17Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z"
        fill="currentColor"
      />
    </svg>
  );
};
